import { React, useState, useEffect } from 'react'
import { Box, Typography, Skeleton } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import AdxButton from 'components/custom/AdxButton'

const BalanceTypeWithout = ({ backgroundLocation, item }) => {
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 1000)
  }, [])

  const applyLeave = () => {
    navigate('/app/leave/request/create', {
      state: {
        backgroundLocation: backgroundLocation,
        selectedLeave: item,
      },
    })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 35px - 70px - 50px)',
      }}
    >
      <Box
        sx={{
          py: { xs: 0, lg: 2 },
          px: { xs: 1.5, lg: 6.25 },
          flex: 1,
        }}
      >
        <Box sx={{ py: 2, display: 'flex', alignItems: 'center' }}>
          {isLoading ? (
            <Box width={'100%'}>
              <Skeleton height={50} />
            </Box>
          ) : (
            <Typography variant="body1" color="light-gray-text.main">
              Leave Days are allocated strictly at Top Management's own discretion.
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            rowGap: 1.25,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'gray-background.main',
              width: '100%',
              py: 0.5,
              px: 1.75,
              my: 2,
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" color="light-gray-text.main">
              Request history
            </Typography>
          </Box>
          <Box
            sx={{
              width: '100%',
              px: 1.75,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="body1" color="light-gray-text.main">
              Days has been requested
            </Typography>

            {isLoading ? (
              <Box width={'50%'}>
                <Skeleton />
              </Box>
            ) : (
              <Typography variant="body1" color="dark-text.main">
                {item.leave_credit.requested === 1 || item.leave_credit.requested === 0
                  ? `${item.leave_credit.requested} day`
                  : `${item.leave_credit.requested} days`}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              width: '100%',
              px: 1.75,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="body1" color="light-gray-text.main">
              Days has been rejected
            </Typography>
            {isLoading ? (
              <Box width={'50%'}>
                <Skeleton />
              </Box>
            ) : (
              <Typography variant="body1" color="dark-text.main">
                {item.leave_credit.rejected
                  ? item.leave_credit.rejected === 1
                    ? `${item.leave_credit.rejected} day`
                    : `${item.leave_credit.rejected} days`
                  : '0 day'}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              width: '100%',
              px: 1.75,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="body1" color="light-gray-text.main">
              Days has been granted
            </Typography>
            {isLoading ? (
              <Box width={'50%'}>
                <Skeleton />
              </Box>
            ) : (
              <Typography variant="body1" color="dark-text.main">
                {item.leave_credit.granted
                  ? item.leave_credit.granted === 1
                    ? `${item.leave_credit.granted} day`
                    : `${item.leave_credit.granted} days`
                  : '0 day'}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          px: { xs: 1.5, lg: 6.25 },
          my: 5,
          width: '100%',
        }}
      >
        <Box
          sx={{
            backgroundColor: 'gray-background.main',
            p: 2.5,
            borderRadius: 2.25,
            width: '100%',
          }}
        >
          {isLoading ? (
            <Box width={'100%'}>
              <Skeleton variant="rectangle" height={60} />
            </Box>
          ) : (
            <Typography variant="body1" color="light-gray-text.main">
              Leaves are allocated strictly at Top Management’sown discretion in the event that you
              are met with an unfortunate event(ie death of a loved one, serious personal problem,
              etc).
            </Typography>
          )}
        </Box>
      </Box>
      <Box sx={{ px: { xs: 1.5, lg: 6.25 }, my: 2, width: '100%' }}>
        <AdxButton onClick={applyLeave} fullWidth>
          Apply Leave
        </AdxButton>
      </Box>
    </Box>
  )
}

export default BalanceTypeWithout
